import React, { useEffect, useState } from 'react';
import {
    Grid,
    Typography,
    Box,
    Paper,
    Stack,
    Divider
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../locale/useTranslation';
import * as API from '../../framework/API/api';
import { LOCALSTORAGE_KEY, MAM_STATUS } from '../../framework/constant/constant';
import SalesDashboardTile from './SalesDashboardTile';
import { utility } from '../../framework/utility/utilityProvider';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';

const WorkflowDashboard = () => {

    const lang = useTranslation();
    const navigate = useNavigate();
    const [transmissonsTiles, setTransmissonsTiles] = useState([]);
    const [mamStatusCardsData, setMamStatusCardsData] = useState([]);

    //DUMMY DATA

    const mediaDataDummy = [
        { type: 'Series', count: 0 },
        { type: 'Season', count: 0 },
        { type: 'Movie', count: 0 },
        { type: 'Program', count: 0 },
        { type: 'Episode', count: 0 },
    ]

    const ingestionPendingDataDummy = [
        { type: 'Movie', count: 0 },
        { type: 'Program', count: 0 },
        { type: 'Episode', count: 0 },
    ]

    const offerPendingDataDummy = [
        { type: 'Series', count: 0 },
        { type: 'Season', count: 0 },
        { type: 'Movie', count: 0 },
        { type: 'Program', count: 0 },
        { type: 'Episode', count: 0 },
    ]

    const transmissionPendingDataDummy = [
        { type: 'Movie', count: 0 },
        { type: 'Program', count: 0 },
        { type: 'Episode', count: 0 },
    ]


    //DEFAULT DATA
    const [mediaData, setMediaData] = useState(mediaDataDummy)

    const [ingestionPendingData, setIngestionPendingData] = useState(ingestionPendingDataDummy)

    const [offerPendingData, setOfferPendingData] = useState(offerPendingDataDummy);

    const [transmissionPendingData, setTransmissionPendingData] = useState(transmissionPendingDataDummy)


    useEffect(() => {
        laodData();
    }, [])

    const setDashboardData = ({ mamData, workflowData, transmissionData }) => {

        console.log({ mamData, workflowData, transmissionData })

        //MAM ASSET TILES
        setMamStatusCardsData(mamData.mamStatusCardsData || []);
        //---------------------------

        //WORKFLOW TILES
        let mediaDataTemp = workflowData?.mediaData.filter((x) => x?.type !== 'Trailer')
        mediaDataTemp = mediaDataDummy.map((x) => {
            let mediaDataItem = mediaDataTemp.find((y) => y && y.type == x.type);
            return { ...x, ...mediaDataItem, route: `/home/MediaEpisode/${x.type}`, state: { category: x.type } }
        })
        setMediaData(mediaDataTemp)

        let ingestionPendingDataTemp = workflowData?.ingestionPending.filter((x) => x?.type !== 'Trailer');
        ingestionPendingDataTemp = ingestionPendingDataDummy.map((x) => {
            let ingestionPendingDataItem = ingestionPendingDataTemp.find((y) => y && y.type == x.type);
            return { ...x, ...ingestionPendingDataItem, route: `/home/manageContent`, state: { category: x.type, hasVersions: false, hasMamAssets: false } }
        })
        setIngestionPendingData(ingestionPendingDataTemp)

        let offerPendingDataTemp = workflowData?.offerPending.filter((x) => x?.type !== 'Trailer')
        offerPendingDataTemp = offerPendingDataDummy.map((x) => {
            let offerPendingDataItem = offerPendingDataTemp.find((y) => y && y.type == x.type);
            return { ...x, ...offerPendingDataItem, route: `/home/manageContent`, state: { category: x.type, hasOffers: false } }
        })
        setOfferPendingData(offerPendingDataTemp)

        let transmissionPendingDataTemp = workflowData?.transmissionPending.filter((x) => x?.type !== 'Trailer');
        transmissionPendingDataTemp = transmissionPendingDataDummy.map((x) => {
            let transmissionPendingDataItem = transmissionPendingDataTemp.find((y) => y && y.type == x.type);
            return { ...x, ...transmissionPendingDataItem, route: `/home/manageContent`, state: { category: x.type, hasTransmissions: false } }
        })
        setTransmissionPendingData(transmissionPendingDataTemp || []);
        //---------------------------

        //TRANSMISSION TILES
        setTransmissonsTiles(transmissionData);
        //---------------------------

    }

    const laodData = async () => {

        let data = utility.getValue(LOCALSTORAGE_KEY.workflowDashboardData);
        console.log(data);
        if (data) {
            setDashboardData(data);
            return;
        }

        console.log("LOADING")

        let mamRes = await API.getImportExportDashboardData();
        let workflowDashboardDataRes = await API.getWorkflowDashboardData();
        let transmissionDataRes = await API.getTransmissonsTiles();

        //SET IN LOCAL STORAGE
        let workflowDashboardData = {
            mamData: mamRes?.data,
            workflowData: workflowDashboardDataRes?.data,
            transmissionData: transmissionDataRes?.data
        };

        utility.setValue(LOCALSTORAGE_KEY.workflowDashboardData, workflowDashboardData);
        setDashboardData(workflowDashboardData);

    };

    //ON REFRESH CLICK CLEAR LOCAL STORAGE
    const onRefresh = () => {
        utility.deleteLocalStorageItem(LOCALSTORAGE_KEY.workflowDashboardData);
        laodData();
    }


    const getMamStatusUI = (status) => {
        switch (status) {
            case "Pending": return { color: "#6c757d", icon: "fa-sharp fa-solid fa-computer", route: `/home/mamAssets?status=${MAM_STATUS.Pending}` };
            case "Ingesting": return { color: "#fd7e14", icon: "fa-sharp fa-solid fa-film", route: `/home/mamAssets?status=${MAM_STATUS.Ingesting}` };
            case "Ingested": return { color: "#0dcaf0", icon: "fa-sharp fa-solid fa-compact-disc", route: `/home/mamAssets?status=${MAM_STATUS.Ingested}` };
            case "Transcoding": return { color: "#6610f2", icon: "fa-sharp fa-solid fa-peace", route: `/home/mamAssets?status=${MAM_STATUS.Transcoding}` };
            case "TXReady": return { color: "#28a745", icon: "fa-sharp fa-solid fa-cash-register", route: `/home/mamAssets?status=${MAM_STATUS.TXReady}` };
            default: return { color: "#0d6efd", icon: "fa-sharp fa-solid fa-podcast", route: "/home/mamAssets" };
        }
    };

    const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8'];
    const pendingColors = ['#FF6B6B', '#4ECDC4', '#45B7D1'];

    const sectionContainerStyle = {
        background: "#ffffff",
        borderRadius: "6px",
        border: "1px solid #e5e7eb",
        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
        padding: "12px",
        marginBottom: "20px"
    };

    const sectionTitleStyle = {
        fontSize: "14px",
        fontWeight: 600,
        color: "#333",
        marginBottom: "6px"
    };

    const dividerStyle = {
        border: "none",
        borderTop: "1px solid #e5e7eb",
        margin: "6px 0 12px 0"
    };


    // Reusable Text Item Component
    const DashboardItem = ({ item, color }) => (
        <Box sx={{ textAlign: 'center', flex: 1, minWidth: 0 }} onClick={() => item?.route && navigate(item.route, { state: item?.state })} style={{ cursor: "pointer" }}>
            <Typography variant="caption" sx={{ fontWeight: 700, opacity: 0.7, textTransform: 'uppercase', fontSize: '0.65rem', letterSpacing: '0.5px', color: '#546e7a', display: 'block', mb: 0.5 }}>
                {item.type}
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1, color: color }}>
                {item.count || item.zeroOffers || 0}
            </Typography>
        </Box>
    );

    return (
        <div style={{ px: 0 }}>
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "-15px" }}><RoundButton icon={"refresh"} style={{ marginRight: '5px', marginBottom: '5px' }} title={lang.refresh_button_tooltip} onClick={onRefresh} /></div>
            {/* workflow header */}
            <div style={sectionContainerStyle}>
                <div style={sectionTitleStyle}>MAM Status</div>
                <hr style={dividerStyle} />
                <div style={{ marginTop: "5px", display: "flex", flexWrap: "nowrap", overflowX: "auto", overflowY: "visible", gap: 12, paddingTop: 10, paddingBottom: 10, scrollbarWidth: "none" }}>
                    {mamStatusCardsData.map((item, index) => {
                        const { color, icon, route } = getMamStatusUI(item?.status);
                        return (
                            <div key={index} style={{ minWidth: 260, flexShrink: 0, paddingTop: 4 }}>
                                <SalesDashboardTile
                                    icon={icon}
                                    iconBackColor={color}
                                    count={item?.count}
                                    status={item?.status}
                                    description={lang.view_details_label}
                                    route={route}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
            <div style={sectionContainerStyle}>
                <div style={sectionTitleStyle}>Workflow</div>
                <hr style={dividerStyle} />
                <Grid sx={{ display: 'grid', gap: 1, gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', px: 0, mx: 0, mb: 5 }}>
                    {/* Media Section */}
                    <Grid item xs={12} md={6} lg={3} >
                        <Paper elevation={3} sx={{ p: 1, borderRadius: 3, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#2c3e50' }}>
                                    Media
                                </Typography>
                                <Box sx={{ textAlign: 'right', lineHeight: 1 }}>
                                    <Typography variant="caption" sx={{ color: '#7f8c8d', fontWeight: 600, fontSize: '0.75rem', display: 'block' }}>
                                        Total
                                    </Typography>
                                    <Typography variant="h4" sx={{ fontWeight: 800, color: '#1976d2', lineHeight: 1 }}>
                                        {mediaData.reduce((acc, item) => acc + item.count, 0)}
                                    </Typography>
                                </Box>
                            </Box>
                            <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={1} sx={{
                                width: '100%', overflow: 'auto', scrollbarWidth: 'none',        // Firefox
                                '&::-webkit-scrollbar': {
                                    display: 'none',             // Chrome, Safari, Edge
                                },
                            }}>
                                {mediaData.map((item, idx) => (
                                    <DashboardItem key={idx} item={item} color={colors[idx]} />
                                ))}
                            </Stack>
                        </Paper>
                    </Grid>

                    {/* Pending Ingestion Section */}
                    <Grid item xs={12} md={6} lg={3}>
                        <Paper elevation={3} sx={{ p: 1, borderRadius: 3, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#2c3e50' }}>
                                    Pending Ingestion
                                </Typography>
                                <Box sx={{ textAlign: 'right', lineHeight: 1 }}>
                                    <Typography variant="caption" sx={{ color: '#7f8c8d', fontWeight: 600, fontSize: '0.75rem', display: 'block' }}>
                                        Pending
                                    </Typography>
                                    <Typography variant="h4" sx={{ fontWeight: 800, color: '#e74c3c', lineHeight: 1 }}>
                                        {ingestionPendingData.reduce((acc, item) => acc + item.count, 0)}
                                    </Typography>
                                </Box>
                            </Box>
                            <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2} sx={{
                                width: '100%', overflow: 'auto', scrollbarWidth: 'none',        // Firefox
                                '&::-webkit-scrollbar': {
                                    display: 'none',             // Chrome, Safari, Edge
                                },
                            }}>
                                {ingestionPendingData.map((item, idx) => (
                                    <DashboardItem key={idx} item={item} color={pendingColors[idx]} />
                                ))}
                            </Stack>
                        </Paper>
                    </Grid>

                    {/* Offer Pending Section */}
                    <Grid item xs={12} md={6} lg={3}>
                        <Paper elevation={3} sx={{ p: 1, borderRadius: 3, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#2c3e50' }}>
                                    Offer
                                </Typography>
                                <Box sx={{ textAlign: 'right', lineHeight: 1 }}>
                                    <Typography variant="caption" sx={{ color: '#7f8c8d', fontWeight: 600, fontSize: '0.75rem', display: 'block' }}>
                                        Pending
                                    </Typography>
                                    <Typography variant="h4" sx={{ fontWeight: 800, color: '#e67e22', lineHeight: 1 }}>
                                        {offerPendingData.reduce((acc, item) => acc + (item.count ?? 0), 0)}
                                    </Typography>
                                </Box>
                            </Box>
                            <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2} sx={{
                                width: '100%', overflow: 'auto', scrollbarWidth: 'none',        // Firefox
                                '&::-webkit-scrollbar': {
                                    display: 'none',             // Chrome, Safari, Edge
                                },
                            }}>
                                {offerPendingData.map((item, idx) => (
                                    <DashboardItem key={idx} item={item} color={colors[idx]} />
                                ))}
                            </Stack>
                        </Paper>
                    </Grid>

                    {/* Transmission Pending Section */}
                    <Grid item xs={12} md={6} lg={3}>
                        <Paper elevation={3} sx={{ p: 1, borderRadius: 3, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#2c3e50' }}>
                                    Transmission
                                </Typography>
                                <Box sx={{ textAlign: 'right', lineHeight: 1 }}>
                                    <Typography variant="caption" sx={{ color: '#7f8c8d', fontWeight: 600, fontSize: '0.75rem', display: 'block' }}>
                                        Pending
                                    </Typography>
                                    <Typography variant="h4" sx={{ fontWeight: 800, color: '#9b59b6', lineHeight: 1 }}>
                                        {transmissionPendingData.reduce((acc, item) => acc + item.count, 0)}
                                    </Typography>
                                </Box>
                            </Box>
                            <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2} sx={{
                                width: '100%', overflow: 'auto', scrollbarWidth: 'none',        // Firefox
                                '&::-webkit-scrollbar': {
                                    display: 'none',             // Chrome, Safari, Edge
                                },
                            }}>
                                {transmissionPendingData.map((item, idx) => (
                                    <DashboardItem key={idx} item={item} color={pendingColors[idx]} />
                                ))}
                            </Stack>
                        </Paper>
                    </Grid>
                </Grid>
            </div>

            {/* Transmission Tiles */}
            <div style={sectionContainerStyle}>
                <div style={sectionTitleStyle}>Transmissions</div>
                <hr style={dividerStyle} />
                <div style={{ marginTop: "5px", display: "flex", flexWrap: "nowrap", overflowX: "auto", overflowY: "visible", gap: 12, paddingTop: 10, paddingBottom: 10, scrollbarWidth: "none" }}>
                    {transmissonsTiles.map((item, index) => {
                        const { color, icon, status, route, count } = item;
                        return (
                            <div key={index} style={{ minWidth: 320, flexShrink: 0, paddingTop: 4 }}>
                                <SalesDashboardTile
                                    icon={icon}
                                    iconBackColor={color}
                                    count={count}
                                    status={status}
                                    description={lang.view_details_label}
                                    route={route}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Reports */}
            <div style={{ flex: 1, ...sectionContainerStyle }}>
                <div style={sectionTitleStyle}>Reports</div>
                <hr style={dividerStyle} />
                <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", padding: "16px", borderRadius: "16px", background: "#f8fafc", boxShadow: "0 6px 20px rgba(0,0,0,0.08)", }}>
                    {[
                        {
                            group: "Schedule",
                            tiles: [
                                { name: "Schedule", color: "#5b88e9", route: "/home/scheduleExport" },
                            ],
                        },
                        {
                            group: "EPG",
                            tiles: [
                                { name: "EPG", color: "#9460ef", route: "/home/epgsExport" },
                            ],
                        },
                        {
                            group: "VOD",
                            tiles: [
                                { name: "VOD Catalogue", color: "#1bdd9f", route: "/home/vodCatalogueExport" },
                                { name: "Node", color: "#ef7e40", route: "/home/nodeReport" },
                                { name: "Transmission List", color: "#ef4f4f", route: "/home/transmissionListReport" },
                            ],
                        },
                        {
                            group: "MAM",
                            tiles: [
                                { name: "Purge List", color: "#9333ea", route: "/home/purgeListReport" },
                                { name: "DubList", color: "#ec66e5", route: "/home/dublistReport" },
                            ],
                        },
                    ].map((group, gIndex) => (
                        <div key={gIndex} style={{ minWidth: "230px", padding: "14px", borderRadius: "14px", background: "#ffffff", boxShadow: "0 4px 14px rgba(0,0,0,0.1)", height: '24vh' }}>
                            <div style={{ fontSize: "14px", fontWeight: 700, marginBottom: "12px", color: "#334155", textAlign: "center", }}>
                                {group.group}
                            </div>
                            {/* Tiles */}
                            <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", justifyContent: "center" }}>
                                {group.tiles.map((item, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            width: "150px",
                                            padding: "14px 10px",
                                            borderRadius: "12px",
                                            background: `linear-gradient(135deg, ${item.color}, ${item.color}cc)`,
                                            color: "#fff",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            transition: "all 0.25s ease",
                                            boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                                        }}
                                        onClick={() => window.open(item.route, "_blank")}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = "translateY(-2px)";
                                            e.currentTarget.style.boxShadow =
                                                "0 8px 18px rgba(0,0,0,0.18)";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = "translateY(0)";
                                            e.currentTarget.style.boxShadow =
                                                "0 4px 12px rgba(0,0,0,0.12)";
                                        }}
                                    >
                                        <i className="fa fa-download" style={{ fontSize: "18px", marginBottom: "6px" }} />
                                        <div style={{ fontSize: "12px", fontWeight: 600, textAlign: "center" }}>
                                            {item.name}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default WorkflowDashboard;